import { ChevronDown, Plus } from "lucide-react";
import { useCanEdit } from "@/model/access";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { NewNodeDialog } from "@/components/nodes/NewNodeDialog";

/** "New event" and "New metric" in the header; one "+ New" menu on narrow screens. */
export function CreateButtons() {
	const [kind, setKind] = useState<"event" | "metric" | null>(null);
	const canEdit = useCanEdit();
	if (!canEdit) return <span className="rounded-full border px-2.5 py-1 text-xs text-muted-foreground">View only</span>;
	return (
		<div className="flex shrink-0 items-center gap-2">
			<div className="hidden items-center gap-2 md:flex">
				<Button variant="outline" size="sm" onClick={() => setKind("event")}>
					<Plus className="size-4" /> New event
				</Button>
				<Button variant="outline" size="sm" onClick={() => setKind("metric")}>
					<Plus className="size-4" /> New metric
				</Button>
			</div>
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<Button variant="outline" className="h-10 md:hidden">
						<Plus className="size-4" /> New <ChevronDown className="size-3.5 opacity-60" />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent align="end" className="w-44">
					<DropdownMenuItem className="py-2.5" onSelect={() => setKind("event")}>
						New event
					</DropdownMenuItem>
					<DropdownMenuItem className="py-2.5" onSelect={() => setKind("metric")}>
						New metric
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenu>
			<NewNodeDialog open={!!kind} onOpenChange={(v) => !v && setKind(null)} kind={kind ?? "event"} />
		</div>
	);
}
